import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TagComponent } from '@tecalisdev/infinity';

/**
 * Tag ACTIVE/INACTIVE del editor (NIF-845). Solo composición `tec-tag`.
 */
@Component({
	selector: 'app-workflow-form-active-status-tag',
	imports: [TagComponent, TranslatePipe],
	template: `
		@if (active) {
			<tec-tag [label]="'MASTER.STATUS.ACTIVE' | translate" status="success" />
		} @else {
			<tec-tag [label]="'MASTER.STATUS.INACTIVE' | translate" status="disabled" />
		}
	`,
})
export class WorkflowFormActiveStatusTagComponent {
	@Input({ required: true }) public active!: boolean;
}
